import qs from 'qs';
import { matchPath, useLocation } from 'react-router-dom';

export function getSearchParams(search) {
  const searchString = search ? search.substr(1) : '';
  return qs.parse(searchString);
}

/**
 * Navigate to the current page with new query string parameters
 */
export function updateCurrentPath(navigate, newParams) {
  const { location } = window;
  const currentParams = getSearchParams(location.search);
  const params = new URLSearchParams({ ...currentParams, ...newParams });
  navigate(`${location.pathname}?${params.toString()}`);
}

export function useRouteMatch(patterns) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

export default getSearchParams;
